const translation = {
  tags: {
    news: 'Nouvelles',
    design: 'Concevoir',
    videos: 'Vidéos',
    agent: 'Agent',
    finance: 'Finance',
    entertainment: 'Divertissement',
    travel: 'Voyager',
    productivity: 'Productivité',
    search: 'Rechercher',
    education: 'Éducation',
    business: 'Affaire',
    weather: 'Temps',
    image: 'Image',
    social: 'Social',
    medical: 'Médical',
    other: 'Autre',
    utilities: 'Utilitaires',
  },
  searchTags: 'Mots-clés de recherche',
  allTags: 'Tous les mots-clés',
}

export default translation
